import { render } from "./MeusAgendamentosCard.vue?vue&type=template&id=bf50b1da&scoped=true"
import script from "./MeusAgendamentosCard.vue?vue&type=script&lang=js"
export * from "./MeusAgendamentosCard.vue?vue&type=script&lang=js"

import "./MeusAgendamentosCard.vue?vue&type=style&index=0&id=bf50b1da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf50b1da"]])

export default __exports__